exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#camaraGaleria{padding:20px;margin:20px 0;border-radius:40px;border:2px solid #ed3a5b;width:90%;max-width:425px}#camaraGaleria .camaraGaleria-text{margin:20px auto;text-align:center;font-size:21px}#camaraGaleria .camaraGaleria-btns-content{display:flex;justify-content:center;align-items:center;flex-direction:column}#camaraGaleria .camaraGaleria-btns-content .btns-content-title{padding:10px 0;font-size:16px;text-transform:uppercase}#camaraGaleria .camaraGaleria-btns{display:flex;justify-content:space-around}#camaraGaleria label.control-localImage input{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a93e5170","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CamaraGaleria.vue
// module id = 21
// module chunks = 0